import { t } from "adapters/i18n";
import type { AgeRange } from "shared/types";
import type { DataResult, ServiceConstructor } from "../services.types";

export function AgeRangeServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class AgeRangeService extends Base {
    readonly ageRangeUrl = `${process.env.REACT_APP_ENDPOINT}herds/ageRange`;

    async listAgeRanges(): Promise<DataResult<AgeRange>> {
      try {
        const result = await this.get(this.ageRangeUrl);

        if (result.data?.data == null) {
          return { data: [], total: 0 };
        }

        const data = result.data.data as AgeRange[];
        const total = result.data.total as number;

        return { data, total };
      } catch (_) {
        throw new Error(t("animalCategory:fetch-age-ranges-error"));
      }
    }
  };
}
